import { ResponsiveContainer, ComposedChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, Line, Legend } from 'recharts';

interface SalesEvolutionChartProps {
  data: Array<{ date: string; amount: number }>;
}

export const SalesEvolutionChart = ({ data }: SalesEvolutionChartProps) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis 
          dataKey="date" 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
        />
        <YAxis 
          stroke="#64748b"
          tick={{ fill: '#64748b', fontSize: 12 }}
          tickLine={{ stroke: '#94a3b8' }}
          tickFormatter={(value) => `${value.toLocaleString()} FCFA`}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: '#fff',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          formatter={(value: number) => [`${value.toLocaleString()} FCFA`, 'Montant']}
          cursor={{ fill: 'rgba(0,0,0,0.05)' }}
        />
        <Legend 
          wrapperStyle={{
            paddingTop: '1rem'
          }}
        />
        <Bar 
          dataKey="amount" 
          fill="#3b82f6" 
          name="Ventes"
          radius={[4, 4, 0, 0]}
        />
        <Line
          type="monotone"
          dataKey="amount"
          stroke="#22c55e"
          name="Tendance"
          dot={false}
          strokeWidth={2}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};